module.exports = [
	{
		"name": "e-mail",
		"link": "mailto:daniel@dvalbrand.com",
		"icon": "envelope-o"
	},
	{
		"name": "LinkedIn",
		"link": "https://www.linkedin.com/in/valbrand",
		"icon": "linkedin-square"
	},
	{
		"name": "Github",
		"link": "https://www.github.com/valbrand",
		"icon": "github"
	},
	{
		"name": "Medium",
		"link": "https://www.medium.com/@Valbrand",
		"icon": "medium"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections/ContactSection/links.json
// module id = 210
// module chunks = 5